<template>
  <div class="homepage-hero">
    <img
      class="homepage2 hidden-sm-and-up"
      src="../../../assets/images/web2/home/homepage-hero-mobile.png">
    <div class="container">
      <div class="content">
        <h1 class="title">Original podcasts you won't find anywhere else.</h1>
        <p class="subtitle">Luminary is a subscription podcast network. Subscribe now to start listening.</p>
        <div class="button-wrapper">
          <el-button
            class="el-button--primary cta-button"
            @click="handleSubscribeClick('home_subscribe_click')">
            Start Free Trial
          </el-button>
          <el-button
            class="el-button btn-transparent cta-button"
            @click="handleShowsClick('home_shows_click')">
            Browse Originals
          </el-button>
        </div>
        <div class="disclaimer-text">
          <p> Cancel Anytime.
            <router-link
              :to="termsLink"
              color="primary"
              target="_blank"
              class= "terms"
              data-test="link-terms"
            >
              Terms apply
            </router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleShowsClick() {
      this.$router.push('/shows');
    },
    handleSubscribeClick() {
      return this.handleCTARouting('homeSubscribeBtn');
    },
  },
};

</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables.scss";

.homepage-hero {
  height: 576px;
  width: 100%;
  position: relative;
  width: 100%;
  padding-bottom: 100px;
  margin-bottom: 50px;
  @media (min-width: $sm) {
    margin-bottom: 0px;
  }
  @media (max-width: $xs) {
    padding-bottom: 30px;
  }
}

.homepage-hero:before {
  @media (min-width: $sm){
    background-image: url(../../../assets/images/web2/home/Luminary-homepage-L-1024x576.png);
  content: "";
  position: absolute;
  top: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
   opacity: 0.2;
  }
}

.homepage2 {
  width: 100%;
  z-index: 1;
}

.content {
  opacity: 1;
  position: relative;
  z-index: 2;
  margin-bottom: 42px;
  @media (min-width: $xs) {
    margin-bottom: 200px;
  }
}

.title {
  color: $white;
  font-family: $serif;
  text-align: center;
  font-size: 28px;
  line-height: 33px;
  margin: 0 auto 20px;
  max-width: 320px;
  padding-top: 37px;
  font-weight: 500;
  letter-spacing:0px;
  @media (min-width: $sm) {
    max-width: 500px;
    font-size: 36px;
    line-height: 42px;
    padding-top: 150px;
  }
  @media (min-width: $md) {
    font-size: 40px;
    line-height: 48px;
  }
  @media (min-width: $lg) {
    font-size: 48px;
    line-height: 56px;
  }
}

.subtitle {
  color: $white;
  text-align: center;
  margin: 0 auto;
  font-size: 18px;
  line-height: 23px;
  margin-bottom: 36px;
  max-width: 250px;
  @media (min-width: $sm) {
    max-width: 428px;
  }
  @media (min-width: $md) {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 48px;
  }
}

.cta-button {
  min-width: 232px;
  padding: 16px 28px;
  font-size: 16px;
  margin-left: 6px;
  margin-right: 6px;
}

.disclaimer-text p{
  text-align: center;
  color: $white;
  font-size: 14px;
  line-height: 40px;
  .terms {
    text-decoration: underline;
    color: $white;
  }
}

.button-wrapper {
  text-align: center;
  .el-button--primary {
    margin-bottom: 20px;
    @media (min-width: $md) {
      margin-bottom: 0px;
    }
  }
}


</style>
